import React from "react";

export default function HeroComex({ titulo, subtitulo, imagen }) {
  return (
    <section className="relative w-full h-[360px] md:h-[420px] lg:h-[540px] flex items-center justify-center overflow-hidden">
      <img
        src={`https://api.institucional.global.sidom.io${imagen}`} // Cambia la ruta si tu imagen está en otro lugar
        alt="Puerto y autos Comex"
        className="absolute top-0 left-0 w-full h-screen object-cover z-0"
        draggable={false}
      />
      {/* Overlay oscuro */}
      <div className="absolute top-0 left-0 w-full h-full bg-sidom-blue/50 z-10" />

      <div className="relative z-20 w-full flex flex-col items-center justify-center px-2">
        <h1 className="text-white text-2xl md:text-4xl lg:text-5xl font-extrabold text-center mb-4 drop-shadow-lg">
          {titulo}
        </h1>
        <p className="text-white text-base md:text-lg lg:text-xl text-center max-w-4xl mx-auto drop-shadow">
          {subtitulo}
        </p>
      </div>
    </section>
  );
}
